import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import clsx from 'clsx';
import SortButton from "../SortButton";
import React, { useState, useEffect } from 'react';

import { createStyles } from "./styles";

var TableHeading = function TableHeading(props) {
  var sorting = props.sorting,sortingKey = props.sortingKey,onSortCallback = props.onSortCallback;

  // React state
  var _useState = useState('DESC'),_useState2 = _slicedToArray(_useState, 2),sortOrder = _useState2[0],setSortOrder = _useState2[1];

  // React effects
  useEffect(function () {
    if (onSortCallback) {
      onSortCallback(sortingKey || '', sortOrder);
    }
  }, [sortOrder]);

  // Component actions
  function onChangeOrder() {
    if (sortOrder === 'ASC') {
      setSortOrder('DESC');
    }
    if (sortOrder === 'DESC') {
      setSortOrder('ASC');
    }
  }

  var onKeyPress = function onKeyPress(e) {
    if (e.keyCode === 13) {
      onChangeOrder();
    }
  };

  var children = props.children,className = props.className;
  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement("th", { className: clsx(classes.tableHeading, className), id: props.id },
    sorting ? /*#__PURE__*/
    React.createElement("div", {
      id: "sort-".concat(props.id),
      className: classes.headingWrapper,
      onClick: onChangeOrder,
      onKeyDown: onKeyPress,
      role: "button",
      tabIndex: 0 }, /*#__PURE__*/

    React.createElement("span", null, children), /*#__PURE__*/
    React.createElement(SortButton, { order: sortOrder })) :


    children));



};

export default TableHeading;
//# sourceMappingURL=index.js.map